import React, { useContext, useEffect, useState } from 'react';
import MainMenu from '../../components/mainmenu';
import Footer from '../../components/mainfooter';

import { Context } from '../../AppContext';
import { ContextUI } from '../../uiContext';
import Service from '../../services/videos';
import Settings from "../../AppSettings";
const createDOMPurify = require('dompurify');
const DOMPurify = createDOMPurify(window);
const Video = (props) => {
    const locationAPI = Settings.getLocationAPI();
    const [videos, setVideos] = useState([]);
    const context = useContext(Context);
    const contextUI = useContext(ContextUI);
    const [selectedVideo, setSelectedVideo] = useState();



    useEffect(() => {
        Service.get().then((response) => {
            if (props.match.params.id) {
                let found = response.find((video) => video._id === props.match.params.id);
                if (found) {
                    setSelectedVideo(found);
                }
            }
            setVideos(response.filter((video) => video.publish));
        }
        );
    }, []);


    if (selectedVideo) {
        return <>
            <MainMenu history={props.history} />
            <br /><br />
            <div style={{padding:'40px'}}>
                <h1>{selectedVideo.title}</h1>
                <video width="60%" height="auto" style={{float:'left',padding:'24px'}} controls >
                    <source src={`${locationAPI}videos/${selectedVideo._id}/download`} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                <div style={{ width: '100%', paddingTop: '18px' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(selectedVideo.content) }} ></div>

             
            </div>
        </>
    }
    return <>
        <MainMenu history={props.history} />
        <br /><br />
        <div className='padding' style={{ display: 'flex', flexWrap: 'wrap' }}>
            {videos.map((video) => {

                return <div onClick={() => { props.history.push('/videos/' + video._id) }} key={video._id} style={{ verticalAlign: 'bottom', cursor: 'pointer', backgroundColor: 'white', backgroundSize: 'cover', backgroundPosition: 'center center', paddingTop: '300px', width: '300px', margin: '20px' }} className=' radius-right shadow' >

                    <video width="270px" style={{ position: 'absolute', marginLeft: '16px', marginTop: -200 }} >
                        <source src={`${locationAPI}videos/${video._id}/download`} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>


                    <div style={{ height: '100px', width: '100%' }}>


                        <div style={{ padding: '12px' }}>  <h2 style={{ fontWeight: 'bolder' }}>{video.title}</h2></div>

                    </div>
                    <br style={{ clear: 'both' }} />
                    <svg width="160" height="60" xmlns="http://www.w3.org/2000/svg" style={{ float: 'right' }}>

                        <path id="svg_3" d="m162.52504,61.04251l0,-62.00002l-166.00001,62.00002l166.00001,0z" fill="#ff7f00" />

                    </svg>

                    <br style={{ clear: 'both' }} />

                </div>

                /* return <div key={video._id} style={{padding:'12px'}}>
                       <video width="720" height="405"  >
                             <source src={`${locationAPI}videos/${video._id}/download`} type="video/mp4" />
                             Your browser does not support the video tag.
                         </video>
                     
                 </div>*/

            })}
        </div>
        <br /><br /> <br /><br /> <br /><br />
        <Footer />

    </>

}

export default Video;